module.exports = __webpack_public_path__ + "img/aussiety-wave-logo.8a7d2658.svg";